import { ReportRowType } from '@features/reports/types/reportRowType'

export const headersToFooters = <T extends { type: ReportRowType }>(rows: T[]): T[] => {
  const sortedRows: T[] = []

  let pendingHeader: T | null = null
  let pendingGroup: T | null = null

  const flush = (row: T | null) => {
    if (row) {
      sortedRows.push(row)
    }
  }

  for (const row of rows) {
    switch (row.type) {
      case ReportRowType.Account:
        sortedRows.push(row)
        break

      case ReportRowType.Group:
        flush(pendingGroup)
        pendingGroup = row
        break

      case ReportRowType.Header:
        flush(pendingGroup)
        pendingGroup = null
        flush(pendingHeader)
        pendingHeader = row
        break

      case ReportRowType.Footer:
        flush(pendingGroup)
        pendingGroup = null
        flush(pendingHeader)
        pendingHeader = null
        sortedRows.push(row)
        break

      default:
        sortedRows.push(row)
        break
    }
  }

  flush(pendingGroup)
  flush(pendingHeader)

  return sortedRows
}
